// dependencies
import React from "react";
import { useIntl } from "react-intl";
import { View, StyleSheet } from "react-native";

// components
import BaseComponent from "../BaseComponent";
import Text from "../Text";
import Stack from "../Stack";
import { IconAvatarO } from "@cloudspire/legacy-svg-icon-library";

// libraries
import { emToPx } from "../../libraries";

// theming
import theming, { IPropsWithTheme } from "../../constants/theming";

const { useTheme } = theming;

type IProps = {
  matches?: boolean;
  fullname: string;
  date: Date;
  composition: string;
} & IPropsWithTheme;

const styles = StyleSheet.create({
  customerContainer: {
    height: "100%",
  },
  customer: {
    justifyContent: "center",
    borderStyle: "solid",
    borderColor: "#000000",

    alignItems: "center",
  },
  avatar: {
    width: emToPx(4.375),
    height: emToPx(4.375),
  },
  answeredAt: {
    fontSize: emToPx(0.875),
  },
  composition: {
    fontSize: emToPx(0.75),
  },
});

const Customer: React.FunctionComponent<IProps> = (props) => {
  const { fullname, date, composition, matches } = props;

  const intl = useIntl();
  const theme = useTheme();

  return (
    <BaseComponent
      containerStyle={styles.customerContainer}
      childrenStyle={[
        styles.customer,
        {
          borderRightWidth: matches ? 2 : 0,
          paddingRight: matches ? emToPx(0.625) : 0,
        },
      ]}
    >
      <View style={styles.avatar}>
        <Text
          style={{ fontSize: emToPx(4), color: theme.PRIMARY_COLOR_DARKEN }}
        >
          <IconAvatarO />
        </Text>
      </View>

      <Stack marginTop={0.5} />

      {fullname && <Text>{fullname}</Text>}

      {composition && <Text style={styles.composition}>{composition}</Text>}

      {!isNaN(date.getTime()) && (
        <Text style={styles.answeredAt}>{intl.formatDate(date.getTime())}</Text>
      )}
    </BaseComponent>
  );
};

export default Customer;
